import { PlayerTable } from "Infrastructure/Components/Tables/PlayerTable";
import { Box } from "@mui/material";

export const PlayersPage = () => {
  return (
    <Box sx={{ height: "calc(100vh - 120px)", overflow: "hidden", p: 4 }}>
      <PlayerTable />
    </Box>
  );
};
